/* istanbul ignore file */
import {
  useInView as useInViewLib,
  IntersectionOptions as IntersectionOptionsLib,
} from 'react-intersection-observer';

export type IntersectionOptions = IntersectionOptionsLib;

export const useInView = useInViewLib;
